import React, {Component} from 'react'
import Router from './../services/Router'
import { UserNavStyle } from './../styles'
import { Nav } from './'
import {connect} from 'react-redux'

const CHALLENGE_ROLE = [
  'ROLE_SELLER',
  'ROLE_STORE_MANAGER',
]


class UserNav extends Component {
  state = {
    nav: [
      {
        value: 'My Information',
        url: Router.information.path
      },
      {
        value: 'Team',
        url: Router.team.exactPath
      },
      {
        value: 'Challenge',
        url: Router.challenge.path
      },
      {
        value: 'Agenda',
        url: Router.event.path
      },
      {
        value: 'Alerts',
        url: Router.counterfeits.path
      },
    ],
  }

  componentDidMount() {
    if (CHALLENGE_ROLE.indexOf(this.props.role) === -1) {
      this.setState({
        nav: this.state.nav.filter((nav) => nav.value !== 'Challenge')
      })
    }


  }

  render() {
    return (
      <div className={`user-nav ${UserNavStyle} no-print`}>
        <h2>
          Hi {this.props.name}, Welcome !
        </h2>
        <Nav nav={this.state.nav} />
      </div>
    )
  }
}

export default connect(
  ({ Session }) => ({
    name: Session.username,
    role: Session.role
  }),
)(UserNav)



// WEBPACK FOOTER //
// ./src/components/UserNav.js